import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every route change jump straight to the top (an animated scroll from the
 * bottom of a long page looks broken). When the URL carries a hash, scroll to
 * that element instead, leaving room for the sticky header.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      // The target may be inside a lazily loaded route; retry briefly.
      let tries = 0;
      const tick = () => {
        const el = document.getElementById(id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top, behavior: 'smooth' });
        } else if (tries++ < 20) {
          window.setTimeout(tick, 100);
        }
      };
      tick();
      return;
    }
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
